import React, { useEffect, useState } from 'react';
import {
    Card, CardBody, CardSubtitle, CardTitle, Col, Container, Row, Label, Input, InputGroup,
    InputGroupText, FormGroup, Button
} from 'reactstrap';
import moment from 'moment';
import { Field, Formik } from 'formik';
import Select, { components } from 'react-select';
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import { default as ReactSelect } from "react-select";
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import PlanSpendPMPM from 'pages/ClientDashBoard/Components/Widgets/PlanSpendPMPM';
import GerenricVsBrandofRx from 'pages/ClientDashBoard/Components/Widgets/GenericvsBrand%Rx';
import PharmacyBySpend from 'pages/ClientDashBoard/Components/Widgets/PharmacyBySpend';
import TopSpecialtyDrugsUtilization from 'pages/ClientDashBoard/Components/Widgets/SpecialityDrugUtilization';
import CostPerRx from 'pages/ClientDashBoard/Components/Widgets/CostPerRx';
import GerenricVsBrandofSpend from './Components/Widgets/GenericvsBrand%Spend';
import PharamacySpendWithRebate from './Components/Widgets/PharamacySpendWithRebates';
import NonSpecialityVsSpecialty from './Components/Widgets/NonSpecialtyvs.SpecialtyDrug';
import getTopDrugsByVolume from './Components/Widgets/TopDrugsByVolume'
import TopDrugsByVolume from './Components/Widgets/TopDrugsByVolume';
import PharmacyByVolume from './Components/Widgets/TopPharmacyByVolume';
import Loader from 'components/Loader';
import PrescriberSpend from './Components/Widgets/PrescriberSpend';
import PrescriberByVolume from './Components/Widgets/TopPrescriberByVolume';
import { RebateAmountSummaryColumns } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import {ClaimWidgetDetailsColumns} from 'utils/columns';
import { onExport } from 'utils/helper';
import DrugCostUtilization from 'pages/Table/DrugcostVsUtilization';
// import EligibilityModel from 'pages/Table/Eligibility';
import DrugClassByPMPM from 'pages/Table/DrugClassByPMPM';
import UtilizationPMPM from 'pages/Table/UtilizationPMPM';
import TopdrugPMPM from 'pages/Table/TopDrugsByPMPM';
import UtilizingMemberSpend from 'pages/Table/TopUtilizingMemberBySpend';
import Top20RebatableDrugs from 'pages/Table/Top20RebatableDrugs';
import EligibleRecord from 'pages/Table/Eligibility';
import DrugTypeAnalysis from './Components/Widgets/DrugTypeAnalysis ';
import FormularyTierMetrics from './Components/Widgets/FormularyTierMetrics';
import PaRates from './Components/Widgets/PaRates';
import RetailvsMailOrderUtilization from './Components/Widgets/RetailvsMailOrderUtilization';
import Scripts100lives from './Components/Widgets/Scripts100lives';
import TopSpecialtyDrugsByPMPM from './Components/Widgets/TopSpecialtyDrugsByPMPM';


let hasDatePopupOpen = false;
let initValue = {
    pbmPlanId: '-1',
    pbmGroupID: '-1',
    dateRange: '3',
    startDate: null,
    endDate: null,
    groupCode:null,
    rebateflag: 'N',
    planCode:null,
}
let startDateSelected = false;
let endDateSelected = false;
//let datavalue = [];
let pharmacyData = [];
let drugVolume = [];
let DrugUtilization = [];
let pharmacybySpend = [];
let prescribervolume =[];
let isChecked = '';
const ClientDashboard = () => {
    const API = useAxios();
    const [dateRange, setDateRange] = useState('3');
    const [planData, setPlanData] = useState([]);
    const [groupData, setGroupData] = useState([]);
    const [planId, setPlanId] = useState([]);
    const [groupId, setGroupId] = useState([]);
    const [pbmPlanId, setPBMPlanId] = useState(-1);
    const [pbmGroupID, setPBMGroupId] = useState(-1);
    const [opaCode, setOPACode] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isHidden, setIsHidden] = useState(true);
    const [iniitalValue, setInitialValue] = useState(initValue);
    const [isSearchDisabled, SetIsSearchDisabled] = useState(false);
    const [customStartDate, setCustomStartDate] = useState(null);
    const [customEndDate, setCustomEndDate] = useState(null);
    //const [isChecked, setIsChaecked] = useState(false)
    //   const[pharmacyData,setPharmacyData]=useState([])
    const [pharmacyVolume, setpharmacyVolume] = useState([]);
    const [specialityVsnonspeciality, setspecialityVsnonspeciality] = useState([]);
    const [genericVsbrandperrx, setgenericVsbrandperrx] = useState([]);
    const [costPerrx, setcostPerrx] = useState([]);
    const [pharmacySpend, setpharmacySpend] = useState([]);
    const [genericVsbrandspend, setgenericVsbrandspend] = useState([]);
    const [pharmacySpendrebate, setpharmacySpendrebate] = useState([]);
    const [prescriberSpend, setprescriberSpend] = useState([]);
    const [loading, setLoading] = useState(false);
    const [summaryData, setSummaryData] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [totalSize, setTotalSize] = useState(0);
    const [drugClassPMPM, setdrugClassPMPM] = useState([]);
     const [drugCostUtilization, setDrugCostUtilization] = useState([]);
     const [top20Rebate, settop20Rebate] = useState([]);
     const [topDrugByPmpm, settopDrugByPmpm] = useState([]);
    const [topUtilizingmember, settopUtilizingMember] = useState([]);
     const [utilizationPmpm, setutilizationPmpm] = useState([]);
      const [Eligibilitydata, setEligibility] = useState([]);

      const [scriptsby100LivesData, setScriptsby100LivesData] = useState([]);
    const[drugTypeAnalysisData,setdrugTypeAnalysisData]=useState([]);
    const[formularyTierMetrics,setformularyTierMetrics]=useState([]);
     const[retailMailData,setretailMailData]=useState([]);
      const[prescriberVolumeData,setprescriberVolumeData]=useState([]);
     const[topSpecialtyDrugsByPMPM,settopSpecialtyDrugsByPMPM]=useState([]);
     const[paApprovedDeniedData,setpaApprovedDeniedData]=useState([]);
     const[planCode,SetPlanCode]=useState([]);
     const [dateError, setDateError] = useState(false);
const [dateErrorMessage, setDateErrorMessage] = useState('');
const [startDateError, setStartDateError] = useState('');
const [endDateError, setEndDateError] = useState('');
  const [edErrorMessage, setEDErrorMessage] = useState('');
    const [sdErrorMessage, setSDErrorMessage] = useState('');
    const[groupCode,setGroupCode]=useState(null);    
   const scriptsData=[];
   const drugData=[];
   const formularyData=[];
   const retailvsMailOrderData=[];
   const TopSpecialtyDrug=[];
   const PAData=[];



    const daterangeoptions = [
        { value: '12', label: '12 Months' },
        { value: '6', label: '6 Months' },
        { value: '3', label: '3 Months' },
        { value: '0', label: 'Custom' }
    ];

    const rebatechecked = isChecked == true ? "Y" : "N"
if(isHidden==false && dateRange ==null && startDate ==null && endDate ==null){
    SetIsSearchDisabled(true);
}

    const handleOnChange = (e) => {
         drugVolume = [];
        DrugUtilization = [];
        prescribervolume = [];
       setStartDate(null);
       setEndDate(null);
        setIsHidden(true)
       setDateRange('3');
        //setGroupData([]);
        // setGroupId([]);
        setpharmacyVolume([]);
        setgenericVsbrandperrx([]);
        setspecialityVsnonspeciality([]);
        setpharmacySpendrebate([]);
        setgenericVsbrandspend([]);
        setpharmacySpend([]);
        setcostPerrx([]);
        setprescriberSpend([]);
        setEligibility([]);
        settop20Rebate([]);
        setdrugClassPMPM([]);
        settopDrugByPmpm([]);
        setDrugCostUtilization([]);
        settopUtilizingMember([]);
        setutilizationPmpm([]);
        settopSpecialtyDrugsByPMPM([]);
        setretailMailData([]);
        setformularyTierMetrics([]);
        setdrugTypeAnalysisData([]);
        setScriptsby100LivesData([]);
        setpaApprovedDeniedData([]);
        startDateSelected = false;
        endDateSelected = false;
        var val = '' + e.value;
        if (e.value == '0') {
            setIsHidden(false);
            SetIsSearchDisabled(true);
        }
        else {
            setIsHidden(true);
            SetIsSearchDisabled(false);
        }
        setDateRange(val);
    }

    const handleSwitch = () => {

    if(isChecked == false || isChecked == ''){
        isChecked = true;
    }else if(isChecked == true){
        isChecked = false
    }
       handleSearch();
        }
    useEffect(() => {
        getPlans();
    }, []);

    const getPlans = async () => {
        try {
            const { data } = await API.post(
                `/PBMConfig/plan/getPlan`);
            if (data) {
                const empPlans = data.filter(item => item. associatedType==="EMP",);
                let options = [];
                for (var x in empPlans) {
                    var row = {};
                    row.planCode = empPlans[x].planCode;
                    row.label = empPlans[x].planDesc + '(' + empPlans[x].planCode + ')';
                    row.value = empPlans[x].pbmPlanID;
                    row.opaCode = empPlans[x].opaCode;
                    options.push(row);
                }
                setPlanData(options);
            }
        } 
        catch (error) {

        }
    };

    const handlePlanChange = (e) => {
        drugVolume = [];
        DrugUtilization = [];
        prescribervolume = [];
        setStartDate(null);
        setEndDate(null);
        setIsHidden(true)
        setDateRange('3');
        setGroupData([]);
        setGroupId([]);
        setpharmacyVolume([]);
        setgenericVsbrandperrx([]);
        setspecialityVsnonspeciality([]);
        setpharmacySpendrebate([]);
        setgenericVsbrandspend([]);
        setpharmacySpend([]);
        setcostPerrx([]);
        setprescriberSpend([]);
        setEligibility([]);
        settop20Rebate([]);
        setdrugClassPMPM([]);
        settopDrugByPmpm([]);
        setDrugCostUtilization([]);
        settopUtilizingMember([]);
        setutilizationPmpm([]);
        settopSpecialtyDrugsByPMPM([]);
        setretailMailData([]);
        setformularyTierMetrics([]);
        setdrugTypeAnalysisData([]);
        setScriptsby100LivesData([]);
        setpaApprovedDeniedData([]);
        let arr = {}
        arr.planCode = -1;
        arr.pbmPlanId = -1;
        arr.pbmGroupID = -1;
        arr.dateRange = dateRange;
        arr.startDate = null;
        arr.endDate = null;
        arr.planCode = -1;
        isChecked = false;
        setInitialValue(arr);

        if (e !== null) {
            setPlanId(e);
            setPBMPlanId(e.value);
            getGroupByCode(e.value);
            setOPACode(e.opaCode);
            SetIsSearchDisabled(false);
            SetPlanCode(e.planCode)
        }
        else {
            getGroupByCode([]);
            setPlanId([]);
            setPBMPlanId(-1);
            setOPACode(null);
            SetPlanCode([])
        }
    }

    const handleGroupChange = (e) => {
         drugVolume = [];
        DrugUtilization = [];
        prescribervolume = [];
        setIsHidden(true)
       setDateRange('3');
        // setStartDate(null);
        // setEndDate(null);
        // setCustomStartDate(null);
        // setCustomEndDate(null);
         setpharmacyVolume([]);
        setgenericVsbrandperrx([]);
        setspecialityVsnonspeciality([]);
        setpharmacySpendrebate([]);
        setgenericVsbrandspend([]);
        setpharmacySpend([]);
        setcostPerrx([]);
        setprescriberSpend([]);
        setEligibility([]);
        settop20Rebate([]);
        setdrugClassPMPM([]);
        settopDrugByPmpm([]);
        setDrugCostUtilization([]);
        settopUtilizingMember([]);
        setutilizationPmpm([]);
        settopSpecialtyDrugsByPMPM([]);
        setretailMailData([]);
        setformularyTierMetrics([]);
        setdrugTypeAnalysisData([]);
        setScriptsby100LivesData([]);
        setpaApprovedDeniedData([]);
        let arr = {}
        arr.planCode = -1;
        arr.pbmPlanId = -1;
        arr.pbmGroupID = -1;
        arr.dateRange = dateRange;
        arr.startDate = null;
        arr.endDate = null;
        arr.planCode = -1;
        isChecked = false;
        setInitialValue(arr);
        if (e !== null) {
            setGroupId(e);
            setPBMGroupId(e.value);
            setGroupCode(e.groupCode);
        }
        else {
            setPBMGroupId(-1);
            setGroupId([]);
             setGroupCode(null);
        }
    }


    const getGroupByCode = async (planId) => {
        try {

            var planCode = {};
            planCode.PlanID = planId;

            var param = {};
            param.filters = planCode;

            const { data } = await API.post(
                `/PBMConfig/group/getGroupByPlanID`, param);
            if (data) {
                let options = [];
                for (var x in data) {
                    var row = {};
                    row.groupCode = data[x].groupCode
                    row.label = data[x].groupDesc + '(' + data[x].groupCode + ')';
                    row.value = data[x].pbmGroupID
                    row.groupCode=data[x].groupCode;
                    options.push(row);
                }
                setGroupData(options);
            }
        }
        catch (error) {
            setGroupData([]);
        }
    }
  const handleStartDate = (startDate) => {  
       let stDate = moment(new Date(startDate)).format('MM/DD/YYYY').split('/');
        ;
        setStartDate(stDate) 
        stDate = moment(new Date(startDate)).format(
            'YYYYMMDD'
          );
        setCustomStartDate(stDate);
        startDateSelected=true;
        resetInitialValues();
    };

    const handleEndDate = (endDate) => {    
       let edDate = moment(new Date(endDate)).format(
          'MM/DD/YYYY'
        ).split('/');
           if (new Date(startDate) > new Date(endDate)) {
                setEDErrorMessage('End date cannot be lesser of start date');
            
                return;
            }
        setEndDate(edDate);
        edDate = moment(new Date(endDate)).format(
            'YYYYMMDD'
          );
        setCustomEndDate(edDate);
        endDateSelected=true;
        resetInitialValues();
    };

    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
   const handleStartDateRaw = (e) => {
  const val = e?.target?.value;
  if (!val || val.trim() === '') {
    setStartDate(null);
    setDateError(false);
    setStartDateError('');
    SetIsSearchDisabled(true);
    return;
  }
  const cleaned = val.replace(/[^0-9/]/g, '');
  const dateParts = cleaned.split('/');
  const [monthStr = '', dayStr = '', yearStr = ''] = dateParts;
  if (!cleaned || cleaned === '__/__/____' || cleaned === '//') {
    setDateError(false);
    setStartDate(null);
    setStartDateError('');
    SetIsSearchDisabled(true);
    return;
  }
  if (monthStr.length === 2) {
    const month = parseInt(monthStr, 10);
    if (isNaN(month) || month < 1 || month > 12) {
      setDateError(true);
      setStartDate(null);
      setStartDateError('Invalid month. Must be 01-12');
      SetIsSearchDisabled(true);
      return;
    } else {
      setDateError(false);
      setStartDateError('');
    }
  }
  if (dayStr.length === 2) {
    const day = parseInt(dayStr, 10);
    if (isNaN(day) || day < 1 || day > 31) {
      setDateError(true);
      setStartDate(null);
      SetIsSearchDisabled(true);
      setStartDateError('Invalid day. Must be 01-31');
      return;
    } else {
      setDateError(false);
      setStartDateError('');
    }
  }
  if (yearStr.length === 4) {
    const year = parseInt(yearStr, 10);
    if (isNaN(year) || year < 1000) {
      setDateError(true);
      setStartDate(null);
      SetIsSearchDisabled(true);
      setStartDateError('Invalid year');
      return;
    } else {
      setDateError(false);
      setStartDateError('');
    }
  }
  if (cleaned.length === 10) {
    const dt = moment(cleaned, 'MM/DD/YYYY', true);
    if (!dt.isValid()) {
      setDateError(true);
      setStartDate(null);
      SetIsSearchDisabled(true);
      setStartDateError('Invalid date. Please check the calendar date.');
      return;
    }
    handleStartDate(new Date(cleaned));
  }
  setDateError(false);
  setStartDateError('');
};
    const handleEndDateRow = (e) => {
  const val = e?.target?.value;
  if (!val || val.trim() === '') {
    SetIsSearchDisabled(true);
  setEndDate(null);
  setDateError(false);
  setEndDateError('');
  return;
}
  const cleaned = val.replace(/[^0-9/]/g, '');
  const dateParts = cleaned.split('/');
  const [monthStr = '', dayStr = '', yearStr = ''] = dateParts;
   if (!cleaned || cleaned === '__/__/____' || cleaned==='//') {
    SetIsSearchDisabled(true);
    setDateError(false);
    setEndDate(null);
    setEndDateError('');
    return;
  }
  if (monthStr.length === 2) {
    const month = parseInt(monthStr, 10);
    if (isNaN(month) || month < 1 || month > 12) {
        SetIsSearchDisabled(true);
      setDateError(true);
      setEndDate(null);
      setEndDateError('Invalid month. Must be 01-12');
      return;
    } else {
      setDateError(false);
      setEndDateError('');
    }
  }
 if (dayStr.length === 2) {
    const day = parseInt(dayStr, 10);
    if (isNaN(day) || day < 1 || day > 31) {
        SetIsSearchDisabled(true);
      setDateError(true);
      setEndDate(null);
      setEndDateError('Invalid day. Must be 01-31');
      return;
    } else {
      setDateError(false);
      setEndDateError('');
    }
  }
   if (yearStr.length === 4) {
    const year = parseInt(yearStr, 10);
    if (isNaN(year) || year < 1000) {
        SetIsSearchDisabled(true);
      setDateError(true);
      setEndDate(null);
      setEndDateError('Invalid year');
      return;
    } else {
      setDateError(false);
      setEndDateError('');
    }
  }

 if (cleaned.length === 10) {
    const dt = moment(cleaned, 'MM/DD/YYYY', true);
    if (!dt.isValid()) {
        SetIsSearchDisabled(true);
      setDateError(true);
      setEndDate(null);
      setEndDateError('Invalid date. Please check the calendar date.');
      return;
    }
    handleEndDate(new Date(cleaned));
  }

   setDateError(false);
  setEndDateError('');
};
 const handleKeyDown = (e) => {
  if (dateError) {
    const allowedKeys = ['Backspace', 'Delete']; // allow only fixing keys
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault(); // block everything else
    }
  }
};



    const resetInitialValues = () => {
        if (!isHidden && startDateSelected == true && endDateSelected == true) {
            SetIsSearchDisabled(false);
        }
        else {
            SetIsSearchDisabled(true);
        }
    }

    const handleSearch = () => {
        let arr = {};
        pharmacyData = []
        arr.pbmPlanId = pbmPlanId;
        arr.pbmGroupID = pbmGroupID;
        arr.dateRange = dateRange;
        arr.startDate = customStartDate;
        arr.endDate = customEndDate;
        arr.planCode= planCode;
        arr.rebateflag = isChecked == true ? "Y" : "N";
        arr.groupCode=groupCode;
        setInitialValue(arr);
        handelGraphsCount(arr);
        handelGraphsSpend(arr);
        handelGraphsgrid(arr);
        getScriptsby1000Lives(arr);
       // getTopSpecialtyDrugByPMPM(arr);
        getRetailvsMailOrderUtilization(arr);
        getAuthPAsAndDenied(arr);
        getEligibility(arr);
    }

    const handleReset = () => {
       SetIsSearchDisabled(true);
        setpharmacyVolume([]);
        setgenericVsbrandperrx([]);
        setspecialityVsnonspeciality([]);
        setpharmacySpendrebate([]);
        setgenericVsbrandspend([]);
        setpharmacySpend([]);
        setcostPerrx([]);
        setprescriberSpend([]);
        setEligibility([]);
        settop20Rebate([]);
        setdrugClassPMPM([]);
        settopDrugByPmpm([]);
        setDrugCostUtilization([]);
        settopUtilizingMember([]);
        setutilizationPmpm([]);
        settopSpecialtyDrugsByPMPM([]);
        setretailMailData([]);
        setformularyTierMetrics([]);
        setdrugTypeAnalysisData([]);
        setScriptsby100LivesData([]);
        setpaApprovedDeniedData([]);
        setPlanId(-1);
        setGroupId(-1);
        setPBMPlanId(-1);
        SetPlanCode(-1);
        setGroupData([]);
        setStartDate(null);
        setEndDate(null);
        setCustomStartDate(null);
        setCustomEndDate(null);
        drugVolume =[];
        DrugUtilization =[];
        prescribervolume =[];
       // handleSwitch();
        startDateSelected = false;
        endDateSelected = false;
        setIsHidden(true);
        setDateRange('3');
        let arr = {};
        arr.pbmPlanId = -1;
        arr.pbmGroupID = -1;
        arr.dateRange = dateRange;
        arr.startDate = null;
        arr.endDate = null;
        arr.planCode= -1;
        isChecked=false;
        setInitialValue(arr);
    }
    const handelGraphsCount = async (arr) => {
        try {
            setLoading(true);
            const { data } = await API.get(
                `/PBMTenant/${arr.pbmPlanId}/PBMClientDashboard/getGraphsCount/${arr.pbmGroupID}/${arr.dateRange}/${arr.startDate}/${arr.endDate}/${arr.rebateflag}`);


            if (data) {
                setpharmacyVolume(data.pharmacyVolumeBarModel),
                    setgenericVsbrandperrx(data.genericvsBrandPercentageofRx),
                    setspecialityVsnonspeciality(data.nonSpecialtyvsSpecialty)
                      drugData.push(data.drugTypeAnalysis)
          setdrugTypeAnalysisData(drugData);
                setLoading(false);
            }

        }
        catch (error) {
            setLoading(false);
        }
    }

    const handelGraphsSpend = async (arr) => {
      
        try {
            setLoading(true);
            const { data } = await API.get(
                `/PBMTenant/${arr.pbmPlanId}/PBMClientDashboard/getGraphsSpend/${arr.pbmGroupID}/${arr.dateRange}/${arr.startDate}/${arr.endDate}/${arr.rebateflag}`);


            if (data) {
              
                setpharmacySpendrebate(data.pharmacySpendGraphModel)
                setgenericVsbrandspend(data.genericvsBrandPercentageofSpend)
                setpharmacySpend(data.pharmacySpendBarModel)
                setcostPerrx(data.costPerRx),
                    setprescriberSpend(data.prescriberSpendBarModel),

                  
                    setLoading(false);

            }

        }
        catch (error) {
            setLoading(false);
        }
    }
  
    
    const handelGraphsgrid=async(arr)=>{
        try{
          setLoading(true);

         const { data } = await API.get(
            `/PBMTenant/${arr.pbmPlanId}/PBMClientDashboard/getGridData/${arr.pbmGroupID}/${arr.dateRange}/${arr.startDate}/${arr.endDate}/${arr.rebateflag}/${arr.planCode}/${arr.groupCode}`);
            if(data)
            
            {
                setdrugClassPMPM(data.drugClassesByPMPMs);
                setDrugCostUtilization(data.drugCostUtilizations);
                settop20Rebate(data.rebatableDrugs);
                settopDrugByPmpm(data.topDrugPMPM);
                settopUtilizingMember(data.utilizingMemberBySpends);
                setutilizationPmpm(data.utilization)
                //   setEligibility(data.eligibility);
                  formularyData.push(data.formularyTierMetrics);
        setformularyTierMetrics(formularyData);
        settopSpecialtyDrugsByPMPM(data.topSpecialtyDrugByPMPM)
                            setLoading(false);

                 
            }
         }
         catch(error){

         }
        }

            const getScriptsby1000Lives=async(values)=>{
                setLoading(true);
const { data } = await API.get(
            `/PBMTenant/${planId.value}/PBMClientDashboard/getScriptsby1000Lives/${values.pbmGroupID}/${values.dateRange}/${values.startDate}/${values.endDate}/${values.planCode}/${values.groupCode}`);
          if (data) {
scriptsData.push(data);
setScriptsby100LivesData(scriptsData)
setLoading(false);
          }
      }
//          const getTopSpecialtyDrugByPMPM=async(values)=>{
// const { data } = await API.get(
//             `/PBMTenant/${planId.value}/PBMClientDashboard/getTopSpecialtyDrugByPMPM/${values.pbmGroupID}/${values.dateRange}/${values.startDate}/${values.endDate}/${values.rebateflag}/${values.planCode}/${values.groupCode}`);
//           if (data) {
// // TopSpecialtyDrug.push(data[0]);
// settopSpecialtyDrugsByPMPM(data);
//           }
//       }

      const getRetailvsMailOrderUtilization=async(values)=>{
                            setLoading(true);
        const { data } = await API.get(
            `/PBMTenant/${planId.value}/PBMClientDashboard/getRetailvsMailOrderUtilization/${values.pbmGroupID}/${values.dateRange}/${values.startDate}/${values.endDate}/${'NPC'}`);
          if (data) {
retailvsMailOrderData.push(data);
setretailMailData(retailvsMailOrderData);
            setLoading(false);

          }
      }
const getAuthPAsAndDenied=async(values)=>{
    setLoading(true);
    const { data } = await API.get(
            `/PBMTenant/${planId.value}/PBMClientDashboard/getAuthPAsAndDenied/${planCode}/${values.pbmGroupID}/${values.dateRange}/${values.startDate}/${values.endDate}/${values.rebateflag}/${'PA'}`);
          if (data) {
   PAData.push(data);
setpaApprovedDeniedData(PAData);
         setLoading(false);
          }
}

const getEligibility= async(values)=>{
    setLoading(true);
 const { data } = await API.get(
            `/PBMTenant/${planId.value}/PBMClientDashboard/getEligibility/${planCode}/${groupCode}/${values.dateRange}/${values.startDate}/${values.endDate}`);
          if (data) {
           
            console.log(data);
         setEligibility(data); 
         setLoading(false); 
          }      
}

    return (
        <div>
            {loading && <Loader opacity={0.01} color='black' />}
            <Container fluid className='my-2 p-4'>
                <ErrorBoundary>
                    <Formik
                        children={(props) => {
                            return (
                                <div>
                                    <div className='row card p-2'>
                                        <Row sm={5}>
                                            <Col md={2}>
                                                {" "}
                                                <Label  className='fw-bold'>Plan</Label>
                                                <ReactSelect
                                                    isClearable={true}
                                                    options={planData}
                                                    isMulti={false}
                                                    value={planId}
                                                    className='required'
                                                    onChange={(e) => handlePlanChange(e)}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <Label  className='fw-bold'>Group</Label>
                                                <Select
                                                    isClearable={true}
                                                    options={groupData}
                                                    isMulti={false}
                                                    value={groupId}
                                                    onChange={(e) => handleGroupChange(e)}
                                                />
                                            </Col>
                                            <Col md={2}>
                                                <Label  className='fw-bold'>Date Range</Label>
                                                <ReactSelect
                                                    options={daterangeoptions} onChange={(e) => handleOnChange(e)}
                                                    value={
                                                        daterangeoptions.filter(option =>
                                                            option.value === dateRange)
                                                    }
                                                    className='required'
                                                />
                                            </Col>
                                            {dateRange == 0 && <>
                                                <Col md={2}>
                                                    <Label>{""}</Label>
                                                               {dateError && (
                                  <label className="text-danger font-size-12">{startDateError}</label>
                                    )}
                                                    <div style={{ "display": "flex", marginTop: "3px" }}>
                                                        <InputGroup onMouseLeave={handleMouseLeave} hidden={isHidden}>
                                                            <Field
                                                                type='text'
                                                                id='startDate'
                                                                name='startDate'
                                                             autoComplete="off"
                                                                placeholder='Start date'
                                                                   className={dateError ? 'is-invalid' : ''} 
                                                                
                                                                value={startDate}
                                                                            onKeyDown={handleKeyDown}                 
                                                                component={FormikDatePicker}
                                                        onChange={(dosStartDate) => handleStartDate(dosStartDate)}
                                                                 onChangeRaw={handleStartDateRaw}
                                                            />
                                                            <InputGroupText
                                                                onClick={() => handleDateClick('startDate')}
                                                            >
                                                                <img src={Calendar} alt='' />
                                                            </InputGroupText>
                                                        </InputGroup>
                                                                 <Label className="text-danger font-size-12">{sdErrorMessage}</Label>
                                                    </div>
                                                </Col>
                                                <Col md={2}>
                                                    <Label>{""}</Label>
                                                     {dateError && (
                                  <label className="text-danger font-size-12">{endDateError}</label>
                                    )}
                                                    <div style={{ "display": "flex", marginTop: "3px" }}>
                                                        <InputGroup onMouseLeave={handleMouseLeave} hidden={isHidden}>
                                                            <Field
                                                                type='text'
                                                                id='endDate'
                                                                name='endDate'
                                                                autoComplete='off'
                                                                placeholder='End date'
                                                                value={endDate}
                                                               
                                                                   className={dateError ? 'is-invalid' : ''} 
                                                                        onKeyDown={handleKeyDown} 
                                                                component={FormikDatePicker}
                                                             onChange={(dosEndDate) => handleEndDate(dosEndDate)}
                                                                  onChangeRaw={handleEndDateRow}
                                                            />
                                                            <InputGroupText
                                                                onClick={() => handleDateClick('endDate')}
                                                            >
                                                                <img src={Calendar} alt='' />
                                                            </InputGroupText>
                                                        </InputGroup>
                                                    </div>
                                                </Col>
                                            </>
                                            }
                                            <Col md={2}>
                                                {/* <Col md={7}> */}
                                                <Label  className='fw-bold'>Include Rebate</Label>
                                                <FormGroup switch>
                                                    <Input

                                                        type="switch"
                                                        role="switch"
                                                        className="f-20 m-auto"
                                                        style={{ margin: "auto" }}
                                                        disabled={pbmPlanId===-1}
                                                        checked={isChecked}
                                                        onChange={handleSwitch}
                                                    />
                                                     < span className="ms-2">{isChecked ? 'ON' : 'OFF'}</span>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {/* </Col> */}
                                        <Row className="d-flex" style={{ justifyContent: "flex-end", paddingTop: "20px" }}>
                                            <Col md="auto" className="">
                                                <Label>{""}</Label>
                                                <Button
                                                    onClick={handleSearch}
                                                    color='primary'
                                                    className="search ms-3"
                                                    disabled={pbmPlanId==-1|| isSearchDisabled}
                                                >
                                                    {/* <span className="right_5">
                                                                <img src={search} alt="" />
                                                            </span>{" "} */}
                                                    Search
                                                </Button>
                                                <Button color='primary' onClick={() => handleReset()}>
                                                    Reset
                                                </Button>
                                            </Col>
                                            {/* <Button
                                                    onClick={handleSearch}
                                                    color='primary'
                                                    className='ms-3'
                                                    disabled={isSearchDisabled}
                                                    >
                                                    Search
                                                </Button> */}


                                            {/* <Button color='primary' onClick={() => handleReset()}>
                                                    Reset
                                                </Button> */}

                                        </Row>

                                    </div>
                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <PlanSpendPMPM dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked} planCode={iniitalValue.planCode} groupCode={iniitalValue.groupCode}/>
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <PharamacySpendWithRebate dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} pharmacySpendrebate={pharmacySpendrebate} rebatechecked={rebatechecked} />
                                        </Col>
                                    </Row>
                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <DrugTypeAnalysis data={drugTypeAnalysisData} searchData={iniitalValue} />
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <EligibleRecord Eligibilitydata={Eligibilitydata} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate}  planCode={iniitalValue.planCode} groupCode={iniitalValue.groupCode} rebatechecked={rebatechecked}/>
                                        </Col>

                                    </Row>
                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <CostPerRx dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} costPerrx={costPerrx} rebatechecked={rebatechecked}/>
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <PaRates data={paApprovedDeniedData} searchData={iniitalValue} />
                                        </Col>
                                    </Row>

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <GerenricVsBrandofRx dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} genericVsbrandperrx={genericVsbrandperrx} rebatechecked={rebatechecked} />
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <GerenricVsBrandofSpend dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} genericVsbrandspend={genericVsbrandspend} rebatechecked={rebatechecked}/>
                                        </Col>

                                    </Row>

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <NonSpecialityVsSpecialty dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} specialityVsnonspeciality={specialityVsnonspeciality} rebatechecked={rebatechecked} />
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <Scripts100lives scriptsby100LivesData={scriptsby100LivesData} searchData={iniitalValue} />
                                        </Col>

                                    </Row>
                                    <Row sm={2} xs={1}>

                                        <Col className='mt-3' md={6}>
                                            <RetailvsMailOrderUtilization data={retailMailData} searchData={iniitalValue} />
                                        </Col>
                                        <Col className="mt-3" md={6}>
                                            <DrugCostUtilization drugCostUtilization={drugCostUtilization} planId={iniitalValue.pbmPlanId}
                                                groupId={iniitalValue.pbmGroupID}
                                                dateRange={iniitalValue.dateRange}
                                                startDate={iniitalValue.startDate}
                                                endDate={iniitalValue.endDate} 
                                                rebatechecked={rebatechecked}/>
                                                
                                        </Col>

                                    </Row>
                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <PharmacyBySpend dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} pharmacySpend={pharmacySpend} rebatechecked={rebatechecked}/>
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <PharmacyByVolume dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} pharmacyVolume={pharmacyVolume} rebatechecked={rebatechecked}
                                            //  setPharmacyData={setPharmacyData}

                                            />
                                        </Col>
                                    </Row>

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <PrescriberSpend dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} prescriberSpend={prescriberSpend} rebatechecked={rebatechecked}/>
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <PrescriberByVolume dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} datavalue={prescribervolume} rebatechecked={rebatechecked} />
                                        </Col>
                                    </Row>
                                    

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <DrugClassByPMPM drugClassPMPM={drugClassPMPM} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked} planCode={planCode} groupCode={groupCode} />
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <UtilizationPMPM utilizationPmpm={utilizationPmpm} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked}/>
                                        </Col>
                                    </Row>

                                    
                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <TopdrugPMPM topDrugByPmpm={topDrugByPmpm} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked} planCode={planCode} groupCode={groupCode}/>
                                        </Col>
                                        <Col className='mt-3' md={6}>
                                            <TopDrugsByVolume dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} datavalue={drugVolume} rebatechecked={rebatechecked} />
                                        </Col>
                                    </Row>

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <TopSpecialtyDrugsByPMPM data={topSpecialtyDrugsByPMPM} searchData={iniitalValue} />
                                        </Col>

                                        <Col className='mt-3' md={6}>
                                            <TopSpecialtyDrugsUtilization dateRange={iniitalValue.dateRange} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} datavalue={DrugUtilization} rebatechecked={rebatechecked} />
                                        </Col>
                                    </Row>

                                    <Row sm={2} xs={1}>
                                        <Col className='mt-3' md={6}>
                                            <UtilizingMemberSpend topUtilizingmember={topUtilizingmember} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked}/>
                                        </Col>

                                        <Col className="mt-3" md={6}>
                                            <Top20RebatableDrugs top20Rebate={top20Rebate} planId={iniitalValue.pbmPlanId} groupId={iniitalValue.pbmGroupID} dateRange={iniitalValue.dateRange} startDate={iniitalValue.startDate} endDate={iniitalValue.endDate} rebatechecked={rebatechecked}/>
                                        </Col>

                                    </Row>
                                    <Row className="mt-3">
                                     <Col className="mt-3" md={6}>
                                        <FormularyTierMetrics data={formularyTierMetrics} searchData={iniitalValue} />
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }}
                    >
                    </Formik>
                </ErrorBoundary>
            </Container>
        </div>
    );
};
export default ClientDashboard;
